<script lang='ts'>
    import { cn } from '@/lib/utils';
    import type {AchievabilityStatus} from '../modules/ProgramAchievability'
    import type { FaIconTypes } from '@/Common/constants';
    export let status: AchievabilityStatus
    export let showCheck = false
    export let faIconType: FaIconTypes = "fa-thin"
    let className: string = undefined
    export {className as class}
</script>

<i 
    class={cn("text-sm", faIconType, className, {
        "text-red-500 fa-circle-xmark": status === "error",
        "text-yellow-500 fa-warning": status === "warning",
        "text-green-500 fa-check-circle": status === "fine",
        "hidden": status === "fine" && !showCheck
    })}
/>